import { firebaseApp } from "./firebase";
import { getFunctions } from 'firebase/functions';

 export const firebaseFunctions = getFunctions(firebaseApp);